import type { AttributesEntity } from '@eliadmin/core/src/api/products/types/product-types';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@eliadmin/core/src/components/ui/select';

import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useEffect, useMemo } from 'react';

/** TODO: handle when no value is present */
export function ProductVariantSelect({
  attribute,
  selectedColor,
  triggerCheck,
}: {
  attribute: AttributesEntity;
  selectedColor: { attribute_id: number; id: number; name: string };
  triggerCheck?: () => void;
}) {
  const selectedVariant = useVariantsStore(s => s.selectedVariant);
  const updateSelectedValue = useVariantsStore(state => state.updateSelectedValue);
  const variants = useVariantsStore(state => state.product.variants) || [];

  useEffect(() => {
    triggerCheck?.();
  }, [selectedColor]);

  const selectedValue = selectedVariant?.values?.find(s => s.attribute_id === attribute.id);

  const handleValueChange = (newValue: string) => {
    const selectedValue2 = attribute.values?.find(value => String(value.id) === String(newValue));
    if (selectedValue2) {
      updateSelectedValue({ attribute, value: selectedValue2 });
    }
    triggerCheck?.();
  };

  return (
    <Select value={String(selectedValue?.id) ?? undefined} onValueChange={handleValueChange}>
      <div
        className={cn(
          'flex w-full flex-col justify-end gap-2 border-none',
          'ea-product-detail-variant__select-wrapper',
        )}
      >
        <SelectTrigger
          aria-label={`${attribute.name}: ${selectedValue?.name ?? 'Vyberte veľkosť'}`}
          className={cn('rounded-none border border-[#D0D0D0] bg-white')}
        >
          <SelectValue className={cn('', 'ea-product-detail-variant__select-value')}>
            {selectedValue?.name ?? 'Vyberte veľkosť'}
          </SelectValue>
        </SelectTrigger>
      </div>
      <SelectContent
        className={cn(
          'flex rounded-none border border-[#D0D0D0] bg-white',
          'ea-product-detail-variant__select-content',
        )}
      >
        {attribute.values?.map(value => {
          const variantMatchingSizeAndColor = variants.find(
            variant =>
              variant.values?.some(
                v => v.attribute_id === selectedColor?.attribute_id && v.id === selectedColor.id,
              ) && variant.values?.some(v => v.attribute_id === attribute.id && v.id === value.id),
          );

          const exists = selectedColor && variantMatchingSizeAndColor;

          if (!exists) {
            return null;
          }

          return (
            <div key={String(value.name)} className="relative">
              <SelectItem
                key={String(value.name)}
                value={String(value.id)}
                className={cn(
                  'flex cursor-pointer flex-row rounded-none',
                  'ea-product-detail-variant__select-item',
                )}
              >
                {value?.name}
              </SelectItem>
              <p
                className={cn(
                  'pointer-events-none absolute right-[32px] top-[6px] text-sm font-semibold',
                  variantMatchingSizeAndColor?.quantity > 0
                    ? 'text-success-foreground'
                    : 'text-destructive-foreground',
                )}
              >
                {variantMatchingSizeAndColor?.quantity > 0 ? (
                  <>{variantMatchingSizeAndColor?.quantity}ks skladom</>
                ) : (
                  <>Na vyžiadanie</>
                )}
              </p>
            </div>
          );
        })}
      </SelectContent>
    </Select>
  );
}
